<template>
    <div :class="[options.class, options.animation, 'flex-column', 'flex-center', 'hover-pointer']" :style="options.style">
        <p class="button-text">{{options.text}}</p>
    </div>
</template>

<script>
export default {
props: {
    options: Object,
},

}
</script>

<style scoped>
    
</style>